module.exports = __webpack_public_path__ + "static/media/battle_start.45843c00.mp3";